module.exports = __webpack_public_path__ + "img/jordan.bc7e0d55.svg";